"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ImageCarouselItem;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Image_1 = __importDefault(require("../Image"));
const useStyles = (0, core_1.makeStyles)(() => ({
    carouselItem: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: (props) => `${props.padding}%`,
        height: 'auto',
    },
    image: {
        width: (props) => `${props.imageWidth}`,
        height: 'auto',
    },
}));
function ImageCarouselItem({ imageUrl, padding, imageWidth, }) {
    const classes = useStyles({ imageUrl, padding, imageWidth });
    return (react_1.default.createElement("div", { className: classes.carouselItem },
        react_1.default.createElement(Image_1.default, { src: imageUrl, alt: imageUrl, className: classes.image })));
}
